"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHttpDelete = exports.useHttpPutBody = exports.useHttpPut = exports.useHttpPostForm = exports.useHttpPostBody = exports.useHttpPost = exports.useHttpGet = exports.useHttpLoading = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var loading_1 = require("remota-client/module/loading");
var object_1 = require("remota-client/util/object");
var api_1 = __importDefault(require("remota-client/util/api"));
var string_1 = require("remota-client/util/string");
var loadingMap = {};
var canLoad = function (id, sv, errorLimit) {
    if (!sv) {
        return true;
    }
    else if (sv.isLoading || sv.isLoaded || (errorLimit > 0 && sv.errors.length > errorLimit)) {
        // 一定回数以上エラーになっている場合読み込み不可
        return false;
    }
    else if (loadingMap[id]) {
        return false;
    }
    else {
        return true;
    }
};
var toStatus = function (id, sv) {
    if (sv) {
        return {
            id: sv.id,
            isLoading: sv.isLoading,
            isLoaded: sv.isLoaded,
            error: sv.errors[0] || null,
        };
    }
    else {
        return { id: id, isLoading: false, isLoaded: false, error: null };
    }
};
var useHttpLoading = function (state, method, url, params, data, headers, isStarted, resultToAction, errorToAction, option) {
    var _a = (option || {}).errorLimit, errorLimit = _a === void 0 ? -1 : _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var key = (0, react_1.useMemo)(function () {
        if (data instanceof FormData) {
            var contents_1 = {};
            data.forEach(function (value, key) {
                if (value instanceof File) {
                    contents_1[key] = { name: value.name };
                }
                else {
                    contents_1[key] = value;
                }
            });
            return "".concat(method, "-").concat(url, "-").concat((0, object_1.getHash)({ params: params, data: contents_1 }));
        }
        return "".concat(method, "-").concat(url, "-").concat((0, object_1.getHash)({ params: params, data: data }));
    }, [method, url, params, data]);
    var id = (0, react_1.useMemo)(function () { return "".concat(key, "-").concat((0, string_1.random)(), "-").concat(Date.now()); }, [key]);
    var sv = state[key];
    (0, react_1.useEffect)(function () {
        if (url === "INVALID" || !isStarted || !canLoad(id, sv, errorLimit)) {
            return;
        }
        loadingMap[id] = true;
        dispatch((0, loading_1.start)(key));
        api_1.default
            .request(method, url, params, data, headers)
            .then(function (res) {
            if (resultToAction) {
                var action = resultToAction(res, data);
                if (action !== undefined) {
                    dispatch(action);
                }
            }
            dispatch((0, loading_1.finish)(key));
        })
            .catch(function (e) {
            if (errorToAction) {
                var action = errorToAction(e);
                if (action !== undefined) {
                    dispatch(action);
                }
            }
            dispatch((0, loading_1.fail)(key, e));
        })
            .finally(function () {
            delete loadingMap[id];
        });
    }, [
        state,
        method,
        url,
        params,
        data,
        headers,
        isStarted,
        resultToAction,
        errorToAction,
        dispatch,
        key,
        id,
        sv,
        errorLimit,
    ]);
    var status = (0, react_1.useMemo)(function () { return toStatus(id, sv); }, [id, sv]);
    return status;
};
exports.useHttpLoading = useHttpLoading;
var useHttpGet = function (state, url, params, isStarted, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useMemo)(function () { var _a, _b; return [{ errorLimit: (_a = option === null || option === void 0 ? void 0 : option.errorLimit) !== null && _a !== void 0 ? _a : 3 }, (_b = option === null || option === void 0 ? void 0 : option.headers) !== null && _b !== void 0 ? _b : {}]; }, [option]), 2), loadingOption = _a[0], headers = _a[1];
    return (0, exports.useHttpLoading)(state, "GET", url, params, null, headers, isStarted, resultToAction, errorToAction, loadingOption);
};
exports.useHttpGet = useHttpGet;
var useHttpPost = function (state, url, data, isStarted, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return [
            { errorLimit: (_a = option === null || option === void 0 ? void 0 : option.errorLimit) !== null && _a !== void 0 ? _a : -1 },
            __assign({ t: Date.now() }, ((_b = option === null || option === void 0 ? void 0 : option.params) !== null && _b !== void 0 ? _b : {})),
            (_c = option === null || option === void 0 ? void 0 : option.headers) !== null && _c !== void 0 ? _c : {},
        ];
    }, [option]), 3), loadingOption = _a[0], params = _a[1], headers = _a[2];
    return (0, exports.useHttpLoading)(state, "POST", url, params, data, headers, isStarted, resultToAction, errorToAction, loadingOption);
};
exports.useHttpPost = useHttpPost;
var useHttpPostBody = function (state, url, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useState)({ body: null, t: null }), 2), bs = _a[0], setBS = _a[1];
    var r2a = (0, react_1.useCallback)(function (res) {
        if (resultToAction) {
            return resultToAction(res);
        }
    }, [resultToAction]);
    var e2a = (0, react_1.useCallback)(function (error) {
        if (errorToAction) {
            return errorToAction(error);
        }
    }, [errorToAction]);
    var start = (0, react_1.useCallback)(function (body) {
        setBS({ body: body, t: Date.now() });
    }, []);
    var params = (0, react_1.useMemo)(function () { return ({ t: bs.t }); }, [bs.t]);
    var isStarted = bs.t !== null;
    var status = (0, exports.useHttpLoading)(state, "POST", url, params, bs.body, {}, isStarted, r2a, e2a, option);
    return (0, react_1.useMemo)(function () { return [start, status]; }, [start, status]);
};
exports.useHttpPostBody = useHttpPostBody;
var useHttpPostForm = function (state, url, data, isStarted, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return [
            { errorLimit: (_a = option === null || option === void 0 ? void 0 : option.errorLimit) !== null && _a !== void 0 ? _a : -1 },
            __assign({ t: Date.now() }, ((_b = option === null || option === void 0 ? void 0 : option.params) !== null && _b !== void 0 ? _b : {})),
            (_c = option === null || option === void 0 ? void 0 : option.headers) !== null && _c !== void 0 ? _c : {},
        ];
    }, [option]), 3), loadingOption = _a[0], params = _a[1], headers = _a[2];
    return (0, exports.useHttpLoading)(state, "POST", url, params, data, headers, isStarted, resultToAction, errorToAction, loadingOption);
};
exports.useHttpPostForm = useHttpPostForm;
var useHttpPut = function (state, url, data, isStarted, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return [
            { errorLimit: (_a = option === null || option === void 0 ? void 0 : option.errorLimit) !== null && _a !== void 0 ? _a : -1 },
            __assign({ t: Date.now() }, ((_b = option === null || option === void 0 ? void 0 : option.params) !== null && _b !== void 0 ? _b : {})),
            (_c = option === null || option === void 0 ? void 0 : option.headers) !== null && _c !== void 0 ? _c : {},
        ];
    }, [option]), 3), loadingOption = _a[0], params = _a[1], headers = _a[2];
    return (0, exports.useHttpLoading)(state, "PUT", url, params, data, headers, isStarted, resultToAction, errorToAction, loadingOption);
};
exports.useHttpPut = useHttpPut;
var useHttpPutBody = function (state, url, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useState)(null), 2), body = _a[0], setBody = _a[1];
    var status = (0, exports.useHttpPut)(state, url, body, body !== null, resultToAction, errorToAction, option);
    return (0, react_1.useMemo)(function () { return [setBody, status]; }, [status]);
};
exports.useHttpPutBody = useHttpPutBody;
var useHttpDelete = function (state, url, isStarted, resultToAction, errorToAction, option) {
    var _a = __read((0, react_1.useMemo)(function () { var _a, _b; return [{ errorLimit: (_a = option === null || option === void 0 ? void 0 : option.errorLimit) !== null && _a !== void 0 ? _a : 3 }, (_b = option === null || option === void 0 ? void 0 : option.headers) !== null && _b !== void 0 ? _b : {}]; }, [option]), 2), loadingOption = _a[0], headers = _a[1];
    return (0, exports.useHttpLoading)(state, "DELETE", url, {}, null, headers, isStarted, resultToAction, errorToAction, loadingOption);
};
exports.useHttpDelete = useHttpDelete;
